import script from "./DateFormatMixin.vue?vue&type=script&lang=js"
export * from "./DateFormatMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__